import * as styles from './AuthHelpText.module.css'

function AuthHelpText({ className = styles.AuthHelpText, text }) {
  return <p className={className}>{text}</p>
}

export default AuthHelpText
